import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const compactInputSx = {
    marginTop: 0,
    marginBottom: 0,
    '& .MuiFilledInput-root': { height: 24, paddingBottom: 0 },
    '& .MuiInputBase-input': { paddingTop: 0, paddingBottom: 0, fontSize: '0.6rem' },
    '& .MuiInputLabel-root': { display: 'none' }
};

export const FormField = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(2)
}));

export const photoBadgeSx = theme => ({
    '& .MuiBadge-badge': {
        fontSize: '0.55rem',
        height: 14,
        minWidth: 14,
        backgroundColor: theme.palette.labelBadge.success.background,
        color: theme.palette.primary.main // darker than labelBadge.success text for legibility at this size
    }
});

export const StyledCommentsField = styled(TextField)({
    width: '100%',
    marginTop: 16,
    marginBottom: 8,
    '& .MuiInputBase-input': { fontSize: '0.65rem' },
    '& .MuiFilledInput-root': { borderRadius: 0, paddingTop: 10 },
    '& .MuiInputLabel-root': { transform: 'translate(12px, -15px) scale(0.75)' }
});
